var styles = {
  "ActionMenu": "Polaris-ActionMenu"
};

export { styles as default };
